module.exports = __webpack_public_path__ + "static/img/footer-menu-icon01.33612e3a.svg";